// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials {
  padding: 3rem 2rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.testimonials-title {
  text-align: center;
  color: #526015;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2rem;
  margin-bottom: 2rem;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.testimonial-card {
  background: #fff;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.testimonial-card:hover {
  transform: translateY(-5px);
}

.testimonial-content {
  margin-bottom: 1.5rem;
}

.testimonial-text {
  color: #526015;
  font-size: 1rem;
  line-height: 1.6;
  font-style: italic;
  margin: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #D4AF37;
}

.author-info {
  display: flex;
  flex-direction: column;
}

.author-name {
  color: #526015;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.1rem;
  margin: 0;
}

.author-role {
  color: #D4AF37;
  font-size: 0.9rem;
  margin: 0.25rem 0 0 0;
}

@media (max-width: 768px) {
  .testimonials-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    max-width: 400px;
    margin: 0 auto;
  }
  
  .testimonials {
    padding: 2rem 1rem;
  }

  .testimonials-title {
    font-size: 1.75rem;
  }

  .testimonial-card {
    padding: 1.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Testimonials.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".testimonials {\n  padding: 3rem 2rem;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.testimonials-title {\n  text-align: center;\n  color: #526015;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.testimonial-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.testimonial-card:hover {\n  transform: translateY(-5px);\n}\n\n.testimonial-content {\n  margin-bottom: 1.5rem;\n}\n\n.testimonial-text {\n  color: #526015;\n  font-size: 1rem;\n  line-height: 1.6;\n  font-style: italic;\n  margin: 0;\n}\n\n.testimonial-author {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.author-image {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #D4AF37;\n}\n\n.author-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.author-name {\n  color: #526015;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.author-role {\n  color: #D4AF37;\n  font-size: 0.9rem;\n  margin: 0.25rem 0 0 0;\n}\n\n@media (max-width: 768px) {\n  .testimonials-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 2rem;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  .testimonials {\n    padding: 2rem 1rem;\n  }\n\n  .testimonials-title {\n    font-size: 1.75rem;\n  }\n\n  .testimonial-card {\n    padding: 1.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
